// import {createRouter, createWebHashHistory} from 'vue-router';
import {createRouter, createWebHistory} from 'vue-router';
import AuthenticationService from '@/service/AuthenticationService';


const routes = [
	{
        path: '/landing',
        name: 'landing',
        component: () => import('./pages/Landing.vue')
    },
	// {   
	// 	path: '/test',
	// 	name: 'test',
	// 	component: () => import('./components/Test.vue')
	// },
	{   
		path: '/oauth/redirect',
		name: 'oauth',
		component: () => import('./pages/OAuth.vue')
	},
	{
		path: '/',
		name: 'home',
		meta: {
			breadcrumb: [{parent:'主页', label:''}]
		},
		component: () => import('./components/Home.vue')
	},
	{
		path: '/proposalinfo/:id',
		name: 'proposalinfo',
		// meta: {
		// 	breadcrumb: [{parent:'主页', label:''}]
		// },
		component: () => import('./components/ProposalInfo.vue')
	},
	{
		path: '/submission',
		name: 'submission',
		meta: {
			breadcrumb: [{parent:'提案申请', label:''}]
		},
		component: () => import('./components/Submission.vue')
	},
	{
		path: '/submissioncreate/:id',
		name: 'submissioncreate',
		meta: {
			breadcrumb: [{parent:'提案申请', label:''}]
		},
		component: () => import('./components/SubmissionCreate.vue')
	},
	{
		path: '/summarize/:id',
		name: 'summarize',
		meta: {
			breadcrumb: [{parent:'提案申请', label:''}]
		},
		component: () => import('./components/Summarize.vue')
	},
	{
		path: '/query',
		name: 'query',
		meta: {
			breadcrumb: [{parent:'提案查询', label:''}]
		},
		component: () => import('./components/Query.vue')
	},
	{
		path: '/approval',
		name: 'approval',
		meta: {
			breadcrumb: [{parent:'提案审核', label:''}]
		},
		component: () => import('./components/Approval.vue'),
		children: [
			{
				path: 'toapproveall',
				name: 'toapproveall',
				component: () => import('./components/ToApproveAll.vue')
			},
			{
				path: 'toapprovepreapprove',
				name: 'toapprovepreapprove',
				component: () => import('./components/ToApprovePreapprove.vue')
			},
			{
				path: 'toapproveapprove',
				name: 'toapproveapprove',
				component: () => import('./components/ToApproveApprove.vue')
			},
			{
				path: 'approved',
				name: 'approved',
				component: () => import('./components/Approved.vue')
			},
		]
	},
	{
		path: '/usermanagement',
		name: 'usermanagement',
		meta: {
			breadcrumb: [{parent:'管理', label:''}]
		},
		component: () => import('./components/UserManagement.vue')
	},
	{
		path: '/noticemanagement',
		name: 'noticemanagement',
		meta: {
			breadcrumb: [{parent:'管理', label:''}]
		},
		component: () => import('./components/NoticeManagement.vue')
	},
	{
		path: '/about',
		name: 'about',
		meta: {
			breadcrumb: [{parent:'关于', label:''}]
		},
		component: () => import('./components/About.vue')
	},
	{
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue')
    },
    {
        path: "/:catchAll(.*)",
        name: 'notfound',
        component: () => import('./components/NotFound.vue')
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('./components/Access.vue')
    },
];

const router = createRouter({
	// mode: 'history',
    // history: createWebHashHistory(),
	history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
	const authenticationService = new AuthenticationService();
	const loggedIn = authenticationService.isloggedIn();

	const publicPages = ['/oauth/redirect', '/login', '/landing'];
	let authRequired = true;
	for (let i = 0; i < publicPages.length; i++) { 
		// console.log(to.path);
		// console.log(publicPages[i]);
		// console.log(window.location.pathname);
		if(to.path.includes(publicPages[i])) {
			authRequired = false;
			break;
		}
		// let beforeHash = window.location.pathname;
		// let afterHash = to.path;
		// if(beforeHash.includes(publicPages[i]) || afterHash.includes(publicPages[i])) {
		// 	authRequired = false;
		// 	break;
		// }
	}

	// console.log(loggedIn);
	// console.log(authRequired);
	
	if (authRequired && !loggedIn) {
		// let url = authenticationService.oauthFullUrl();
		// let url = '/assets/pages/landing.html';
		// window.location = url;
		let url = '/landing';
		next(url);
		return;
	}
  
	next();
});


export default router;